export const authGoogleKey = 'AuthGoogleLogin';
export const authGoogleClientId =
  '1070700241188-uv3df9u3jbo9qg379u8m2g4qe15o6155.apps.googleusercontent.com';
